/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Public_Adjust_SettingsInputs */

const en_pricing_public_adjust_settings = /** @type {(inputs: Pricing_Public_Adjust_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust settings`)
};

const es_pricing_public_adjust_settings = /** @type {(inputs: Pricing_Public_Adjust_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar configuración`)
};

/**
* | output |
* | --- |
* | "Adjust settings" |
*
* @param {Pricing_Public_Adjust_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_public_adjust_settings = /** @type {((inputs?: Pricing_Public_Adjust_SettingsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Public_Adjust_SettingsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_public_adjust_settings(inputs)
	return es_pricing_public_adjust_settings(inputs)
});